import Box from "ReusableComponents/Box";
import Button from "ReusableComponents/Button";
import Text from "ReusableComponents/Text";
import { apiClient } from "api/apiClient";
import { useEffect, useState } from "react";
import { COLORS, SIZES, WEIGHT } from "theme";
import {
  ERROR_CODES,
  generateUid,
  getBrands,
  getCityOfState,
  getStates,
  isValidEmail,
} from "utils";
import "./form.css";

import { useLanguage } from "LanguageContext";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const TestDriveForm = ({ getStatus, small, bannerData, selectedVehicle }) => {
  const [hover, setHover] = useState(false);
  const [hover1, setHover1] = useState(false);

  const location = useLocation();
  const BRANDS = getBrands().map((item) => Object.keys(item));
  const [otpSent, setOtpSent] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [showVehicalOptions, setShowVehicalOptions] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [utm, setUtm] = useState(false);
  const [brands, setBrands] = useState(BRANDS[0]);
  const history = useHistory();
  const [showroomLocation, setshowroomLocation] = useState([]);
  const [usageCityError, setUsageCityError] = useState("");
  const [filteredShowrooms, setFilteredShowrooms] = useState([]);
  const [disableButton, setDisableButton] = useState(false);
  const [otpLoad, setOtpLoad] = useState(false);
  const { selectedLanguage } = useLanguage();

  const [state, setState] = useState({
    first_name: "",
    last_name: "",
    email_address: "",
    phone_number: "",
    state: "Delhi",
    city: "Delhi",
    usage_state: "",
    usage_city: "",
    pincode: "",
    days: "",
    otp_verified: "",
    purchase_plan: "Within 7 days",
    finance_required: "false",
    vehicle_ownership: "No",
    vehicle_type: "",
    brand: "",
    model: "",
    phone_number_verified: false,
    otp: "",
    authorize_communication: false,
    application_id: generateUid("RIDE"),
    utm_medium: "",
    utm_source: "",
    utm_campaign: "",
    gclid: "",
  });

  useEffect(() => {
    apiClient
      .getStoreLocation()
      .then((res) => {
        if (res && res.data) {
          setshowroomLocation(res.data);
        } else {
          console.error("Error: Invalid or empty response from API");
        }
      })
      .catch((error) => {
        console.error("Error fetching store locations:", error);
      });
  }, []); // empty dependency array ensures this runs only once

  const getShowroom = (state, city) => {
    return showroomLocation.filter(
      (location) =>
        location.attributes.state_located.data.attributes.state_name ===
          state &&
        location.attributes.city_located.data.attributes.city_name === city
    );
  };
  useEffect(() => {
    if (state.usage_state && state.usage_city) {
      const filtered = getShowroom(state.usage_state, state.usage_city);
      setFilteredShowrooms(filtered);
      console.clear();
      console.log(filteredShowrooms);
      if (filtered.length === 0) {
        setUsageCityError(ERROR_CODES.notServiceable);
      } else {
        setUsageCityError("");
      }
    }
  }, [state.usage_state, state.usage_city]);
  // useEffect(() => {
  //   const utm_medium = sessionStorage.getItem("utm_medium");
  //   const utm_source = sessionStorage.getItem("utm_source");
  //   const utm_campaign = sessionStorage.getItem("utm_campaign");
  //   const gclid = sessionStorage.getItem("gclid");

  //   if (utm_medium || utm_source || utm_campaign) {
  //     setState({ ...state, utm_medium, utm_source, utm_campaign, gclid });
  //   }
  //   window.onbeforeunload = function () {
  //     const data = {
  //       uuid: generateUid("RIDE"),
  //       data: state,
  //       form_name: "Test-Ride",
  //       utm_source: utm_source,
  //       utm_medium: utm_medium,
  //       utm_campaign: utm_campaign,
  //       gclid: gclid,
  //     };
  //     apiClient.submitTestDrive(data);
  //     return "Are you sure you want to leave this page?";
  //   };
  // }, [state]);

  const handleChangePhoneNumber = (e) => {
    setError(false);
    const { value } = e.target;
    if (value.match(/^\d{0,10}$/)) setState({ ...state, phone_number: value });
  };

  const handleChange = (e) => {
    setError(false);

    if (e.target.name == "city" && e.target.value == "Delhi") {
      setState((prevState) => ({ ...prevState, [e.target.name]: "New Delhi" }));
      return;
    }
    if (e.target.name == "usage_city" && e.target.value == "Delhi") {
      setState((prevState) => ({ ...prevState, [e.target.name]: "New Delhi" }));
      return;
    }
    if (e.target.value === "None") return;
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const getOtp = () => {
    setDisableButton(true);
    setOtpLoad(true);

    if (!state.phone_number.match(/^\d{10}$/)) {
      setError(ERROR_CODES.invalidPhone);
      return;
    }
    const num = "91" + state.phone_number;
    setOtpLoad(true);
    apiClient
      .getOtp(num)
      .then((res) => {
        console.log(res);
        if (res?.code === "ERR_NETWORK") {
          setError(ERROR_CODES.OtpError);
          setOtpLoading(false);
          return;
        }

        setOtpSent(true);
        setOtpLoading(false);
      })
      .catch((err) => {
        if (err?.code === "ERR_NETWORK") {
          setError(ERROR_CODES.OtpError);
          setOtpLoading(false);
          return;
        }
      });
    setTimeout(() => {
      setOtpLoading(false);
      setDisableButton(false);
    }, 10000);
  };

  useEffect(() => {
    if (state.vehicle_ownership === "Yes") {
      setShowVehicalOptions(true);
    } else setShowVehicalOptions(false);
  }, [state.vehicle_ownership]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    

    // Check if all required fields are filled
    if (
      !state.first_name ||
      !state.last_name ||
      !state.state ||
      !state.city ||
      !state.pincode ||
      !state.email_address ||
      !state.usage_state ||
      !state.usage_city ||
      !state.otp
    ) {
      setError(ERROR_CODES.missingFields);
      return;
    }

    // Check if OTP is provided
    if (!state.otp) {
      setError(ERROR_CODES.verifyPhone);
      return;
    }

    // Validate email address
    if (!isValidEmail(state.email_address)) {
      setError(ERROR_CODES.invalid?.email);
      return;
    }

    setError("");
    setLoading(true);

    try {
      const res = await apiClient.verifyOtp(
        "91" + state.phone_number,
        state.otp
      );

      if (
        res &&
        (res.message.type === "success" ||
          res.message.message.includes("already verified"))
      ) {
        setError("");
        const data = {
          ...state,
          phone_number_verified: true,
          vehicle_type: selectedVehicle,
        };
        const response = await apiClient.submitBookPilot(data);
        getStatus(response?.data?.attributes);

        history.push({
          pathname: `/${selectedLanguage}/thank-you-test-drive`,
          state: {
            booked: true,
            bookingDetails: response?.data?.attributes,
            bannerData,
            small,
          },
        });

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: "Book a Test Ride",
          formType: "Test_Ride_form",
        });

        console.log("Book Test Form Event Fired");

        
      } else {
        setError(ERROR_CODES.otpMisMatch);
      }
    } catch (error) {
      console.log(error);
      setError(ERROR_CODES.otpMisMatch);
    }
    setLoading(false);
  };

  const getBrandOptions = () => {
    if (state.vehicle_type)
      switch (state.vehicle_type) {
        case "3 Wheeler":
          return setBrands(BRANDS[0]);
        default:
          return setBrands(BRANDS[1]);
      }
  };

  const handleChangeOtp = (e) => {
    const { value } = e.target;
    if (!value || value.match(/^\d{0,4}$/)) setState({ ...state, otp: value });
  };

  return (
    <>
      <div className="form_container">
        <form action="#">
          <h3 className="form_section_heading">Personal Information</h3>
          <div className="form-row">
            <div className="form_field">
              <label className="field_label" for="first_name_field">
                First Name <span className="mandatory">*</span>
              </label>
              <input
                className="input_box"
                type="text"
                value={state.name}
                onChange={handleChange}
                name="first_name"
                placeholder="Enter First Name"
                id="first_name_field"
                required
              />
            </div>
            <div className="form_field">
              <label className="field_label" for="last_name_field">
                Last Name <span className="mandatory">*</span>
              </label>
              <input
                className="input_box"
                type="text"
                name="last_name"
                value={state.last_name}
                onChange={handleChange}
                placeholder="Enter Last Name"
                id="last_name_field"
                required
              />
            </div>
            <div className="form_field">
              <label className="field_label" for="email_field">
                Email <span className="mandatory">*</span>
              </label>
              <input
                className="input_box"
                type="text"
                name="email_address"
                value={state.email_address}
                onChange={handleChange}
                placeholder="Enter Email Address"
                id="email_field"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form_field">
              <label className="field_label" for="state_field">
                State <span className="mandatory">*</span>
              </label>

              <Box position="relative">
                <select
                  style={{
                    background: "none",
                    color: "black",
                  }}
                  className="input_box"
                  onChange={handleChange}
                  name="state"
                  required
                >
                  <option value="None" selected disabled>
                    Select State
                  </option>
                  {getStates().map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                <i
                  className="arrow down"
                  style={{
                    position: "absolute",
                    top: "0px",
                    right: "10px",
                  }}
                ></i>
              </Box>
            </div>
            <div className="form_field">
              <label className="field_label" for="city_field">
                City <span className="mandatory">*</span>
              </label>
              <select
                style={{
                  background: "none",
                  color: "black",
                }}
                className="input_box"
                onChange={handleChange}
                name="city"
                required
              >
                <option value="None" selected disabled>
                  Select City
                </option>

                {state.state &&
                  getCityOfState(state.state).map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
              </select>
            </div>

            <div className="form_field">
              <label className="field_label" for="pincode_field">
                Pincode <span className="mandatory">*</span>
              </label>
              <input
                className="input_box"
                inputmode="numeric"
                maxLength={6}
                type="text"
                name="pincode"
                value={state.pincode}
                onChange={handleChange}
                placeholder="Enter Pincode"
                id="pincode_field"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form_field">
              <label className="field_label" for="state_field">
                Usage State <span className="mandatory">*</span>
              </label>

              <Box position="relative">
                <select
                  style={{
                    background: "none",
                    color: "black",
                  }}
                  className="input_box"
                  onChange={handleChange}
                  name="usage_state"
                  required
                >
                  <option value="None" selected disabled>
                    Select Usage State
                  </option>
                  {getStates().map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                <i
                  className="arrow down"
                  style={{
                    position: "absolute",
                    top: "0px",
                    right: "10px",
                  }}
                ></i>
              </Box>
            </div>
            <div className="form_field">
              <label className="field_label" for="city_field">
                Usage City <span className="mandatory">*</span>
              </label>
              <select
                style={{
                  background: "none",
                  color: "black",
                }}
                className="input_box"
                onChange={handleChange}
                name="usage_city"
                required
              >
                <option value="None" selected disabled>
                  Select Usage City
                </option>

                {state.usage_state &&
                  getCityOfState(state.usage_state).map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          {usageCityError && (
            <p style={{ color: "red", fontWeight: WEIGHT.bold }}>
              {usageCityError}
            </p>
          )}
          {/* <div className="form-row">
            <div className="form_field">
              <label className="field_label">
                When are you planning to purchase the vehicle?{" "}
              </label>
              <div
                className="radio_container"
                value={state.purchase_plan}
                onChange={handleChange}
              >
                <div>
                  <input
                    className="radio_box"
                    type="radio"
                    name="purchase_plan"
                    defaultChecked
                    id="WI7D"
                    value="Within 7 days"
                  />
                  <label className="radio_label" for="WI7D">
                    Within 7 days
                  </label>
                </div>
                <div>
                  <input
                    className="radio_box"
                    type="radio"
                    name="purchase_plan"
                    value="Within a month"
                    id="WI1M"
                  />
                  <label className="radio_label" for="WI1M">
                    Within a month
                  </label>
                </div>
                <div>
                  <input
                    className="radio_box"
                    type="radio"
                    name="purchase_plan"
                    value="After a month"
                    id="A1M"
                  />
                  <label className="radio_label" for="A1M">
                    After a month
                  </label>
                </div>
                <div>
                  <input
                    className="radio_box"
                    type="radio"
                    name="purchase_plan"
                    value="Not decided"
                    id="ND"
                  />
                  <label className="radio_label" for="ND">
                    Not decided
                  </label>
                </div>
              </div>
            </div>
            <div className="form_field">
              <label className="field_label">
                Finance Required <span className="mandatory">*</span>
              </label>
              <div
                className="radio_container"
                value={state.finance_required}
                onChange={handleChange}
              >
                <div>
                  <input
                    className="radio_box"
                    type="radio"
                    name="finance_required"
                    value="Yes"
                    id="finance_yes"
                    required
                  />
                  <label className="radio_label" for="finance_yes">
                    Yes
                  </label>
                </div>

                <div>
                  <input
                    className="radio_box"
                    type="radio"
                    name="finance_required"
                    value="No"
                    id="finance_no"
                    required
                  />
                  <label className="radio_label" for="finance_no">
                    No
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="form_field">
              <label className="field_label">Do you own any vehicle?</label>
              <div className="radio_container" onChange={handleChange}>
                <div>
                  <input
                    className="radio_box"
                    type="radio"
                    name="vehicle_ownership"
                    value={"Yes"}
                    checked={state.vehicle_ownership === "Yes"}
                    id="ownership_yes"
                    required
                  />
                  <label className="radio_label" for="ownership_yes">
                    Yes
                  </label>
                </div>
                <div>
                  <input
                    className="radio_box"
                    type="radio"
                    name="vehicle_ownership"
                    value="No"
                    id="ownership_no"
                    checked={state.vehicle_ownership === "No"}
                    required
                  />
                  <label className="radio_label" for="ownership_no">
                    No
                  </label>
                </div>
              </div>
            </div>
          </div>

          {showVehicalOptions && (
            <div className="form-row">
              <div className="form_field">
                <label className="field_label" for="vehicle_type_field">
                  Owned Vehicle Type{" "}
                </label>
                <select
                  className="input_box"
                  type="text"
                  name="vehicle_type"
                  id="vehicle_type_field"
                  onChange={handleChange}
                >
                  <option value={"None"}>Select vehicle type</option>
                  {getTrucks.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form_field">
                <label className="field_label" for="brand_field">
                  Brand{" "}
                </label>
                <select
                  className="input_box"
                  type="text"
                  name="brand"
                  id="brand_field"
                  value={state.brand}
                  onChange={handleChange}
                >
                  <option value="None">Select Brand</option>

                  {state.vehicle_type && (
                    <>
                      {brands.map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </>
                  )}
                </select>
              </div>
              <div className="form_field">
                <label className="field_label" for="model_field">
                  Model{" "}
                </label>
                <select
                  className="input_box"
                  type="text"
                  name="model"
                  id="model_field"
                  value={state.model}
                  onChange={handleChange}
                >
                  <option value="None">Select Model</option>

                  {state.vehicle_type && state.brand && (
                    <>
                      {TRUCKS[state.vehicle_type][state.brand] &&
                        TRUCKS[state.vehicle_type][state.brand].map((item) => (
                          <option key={item} value={item} selected={item}>
                            {item}
                          </option>
                        ))}
                    </>
                  )}
                </select>
              </div>
            </div>
          )} */}

          <div className="form-row">
            <div className="form_field">
              <label className="field_label" for="phone_number_field">
                Phone Number <span className="mandatory">*</span>
              </label>
              <input
                className="input_box"
                value={state.phone_number}
                maxLength={10}
                onChange={handleChangePhoneNumber}
                type="text"
                name="phone_number"
                placeholder="Enter 10 Digit Phone Number"
                id="phone_number_field"
                required
              />
            </div>
            <div style={{ paddingTop: small ? "0px" : "30px" }}>
              <div
                className="btn_primary"
                onClick={disableButton ? null : getOtp}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  pointerEvents: loading ? "none" : "auto",
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.5 : 1,
                  height: "50px",
                  alignSelf: small && "start",
                  transition: "opacity 10s ease-in-out",
                }}
                disabled={disableButton}
              >
                <Text
                  fontSize={"16px"}
                  fontWeight="bold"
                  textColor={hover1 ? COLORS.white : COLORS.black}
                >
                  {otpLoading ? "Sending..." : "Get OTP"}
                </Text>
              </div>
            </div>
          </div>

          {otpSent && (
            <>
              <div className="form-row">
                <div
                  className="otp_snackbar"
                  id="otp_snackbar"
                  style={{ width: small && "auto" }}
                >
                  OTP Sent
                </div>
              </div>
              <div className="form-row">
                <div className="form_field">
                  <label className="field_label" for="otp_field">
                    OTP <span className="mandatory">*</span>
                  </label>
                  <input
                    value={state.otp}
                    onChange={handleChangeOtp}
                    className="input_box"
                    type="text"
                    name="otp"
                    placeholder="Enter OTP"
                    id="otp_field"
                    required
                    maxLength={4}
                  />
                </div>
                {/* <div className="btn_ul">Change Number</div>
              <div className="btn_ul" onClick={resendOtp}>
                Resend OTP
              </div> */}
              </div>
            </>
          )}

          <div className="form-row">
            <div className="radio_container">
              <div>
                <input
                  className="radio_box"
                  type="radio"
                  name="authorize_communication"
                  id="authorized"
                  value="yes"
                  required
                  onChange={handleChange}
                />
                <label className="radio_label" for="authorized">
                  <span className="mandatory">*</span>I authorise Euler Motors
                  to contact me via SMS, Email, Whatsapp and other modes of
                  communication.
                </label>
              </div>
            </div>
          </div>

          <div className="form-row">
            <Button
              display="flex"
              w="218px"
              cursor={loading ? "not-allowed" : "pointer"}
              pointerEvents={loading ? "none" : "auto"}
              opacity={loading ? 0.5 : 1}
              hoverBackground={true}
              justifyContent="center"
              background={hover ? COLORS.black : COLORS.primary}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              onClick={handleSubmit}
            >
              <Text
                fontSize={small ? SIZES.twelve : "16px"}
                fontWeight="bold"
                textColor={hover ? COLORS.white : COLORS.black}
              >
                Verify and Submit
              </Text>
            </Button>
            {error && (
              <p style={{ color: "red", fontWeight: WEIGHT.bold }}>{error}</p>
            )}
          </div>

          <div className="form-row">
            <div className={small ? "contact_info" : "contact_info_web"}>
              <p>Trouble booking? Reach out to us at</p>
              <strong className="contact_info_number">1800 1238 1238</strong>.
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default TestDriveForm;
